import { useQuery } from '@apollo/client';
import { GET_STREAM_MATCHUPS } from 'api/matchup/queries';
import {
  GetStreamMatchups,
  GetStreamMatchupsVariables,
} from 'api/matchup/types/GetStreamMatchups';

export const useGetStreamMatchups = (
  streamId?: string | null,
  { skip = false }: { skip?: boolean } = {}
) => {
  const { data, loading, error, refetch } = useQuery<
    GetStreamMatchups,
    GetStreamMatchupsVariables
  >(GET_STREAM_MATCHUPS, {
    variables: { streamId: streamId || '' },
    skip: !streamId || skip,
    fetchPolicy: 'cache-and-network',
  });

  return {
    matchups: data?.getStreamMatchups ?? [],
    loading,
    error,
    refetch,
  };
};
